module.exports = __webpack_public_path__ + "static/media/reward-es.39567aa8.webp";